document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('.product-offer');

  sections.forEach(section => {
    const mainEl = section.querySelector('.product-offer__main-slider');
    const navEl = section.querySelector('.product-offer__nav-slider');

    if (!mainEl) return;

    function syncNavHeight() {
      if (!navEl) return;
      navEl.style.height = mainEl.offsetHeight + 'px';
    }

    syncNavHeight();
    window.addEventListener('resize', syncNavHeight);

    let sliderThumbnail = null;

    if (navEl) {
      sliderThumbnail = new Swiper(navEl, {
        slidesPerView: 5,
        spaceBetween: 12,
        direction: 'vertical',
        watchSlidesProgress: true,
      });
    }

    const nextBtn = section.querySelector('.swiper-button-next-button');
    const prevBtn = section.querySelector('.swiper-button-prev-button');

    new Swiper(mainEl, {
      spaceBetween: 8,
      slidesPerView: 1.06,
      loop: true,

      thumbs: sliderThumbnail ? { swiper: sliderThumbnail } : undefined,

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      breakpoints: {
        581: {
          slidesPerView: 1,
          loop: false,
        }
      }
    });
  });
});

// product offer
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.product-offer');

  sections.forEach(section => {
    const variantItems = section.querySelectorAll('.product-offer__variant-item');
    const variantInput = section.querySelector('[id^="selected-variant-id"]');
    const buyNowBtn = section.querySelector('[id^="buy-now"]')
    const form = buyNowBtn.closest('form');
    const stickyPrice = section.querySelector('.product-offer__sticky .btn-price');

    const subscriptionCheckbox = section.querySelector('[id^="offer-subscription"]');

    const btnPrice = buyNowBtn.querySelector('.btn-price');
    const btnCompare = buyNowBtn.querySelector('.btn-compare');

    form.addEventListener('submit', e => e.preventDefault());

    function getSelectedVariant() {
      return section.querySelector('.product-offer__variant-item.selected');
    }

    function updateDiscountBar() {
      const bar = section.querySelector('[data-ka-discount-bar]');
      if (!bar) return;
      const selected = getSelectedVariant();
      const textEl = bar.querySelector('[data-ka-discount-bar-text]');
      const priceEl = bar.querySelector('[data-ka-discount-bar-price]');
      const compareEl = bar.querySelector('[data-ka-discount-bar-compare]');
      if (!selected || !textEl) return;

      const isSub = subscriptionCheckbox?.checked;
      const suffix = bar.getAttribute('data-suffix') || 'Off Auto-Applied Today ✅';
      const otpPriceText = selected.dataset.price;
      const subPriceText = selected.dataset.subscriptionPrice;
      const priceText = isSub && subPriceText ? subPriceText : otpPriceText;
      let compareText = selected.dataset.comparePrice;
      const otpCents = parseInt(selected.dataset.priceCents, 10) || 0;
      const subCents = parseInt(selected.dataset.subscriptionCents, 10) || 0;
      const priceCents = isSub && subCents ? subCents : otpCents;
      let compareCents = parseInt(selected.dataset.compareCents, 10) || 0;
      if (compareCents <= priceCents && isSub && otpCents > priceCents) {
        compareCents = otpCents;
        compareText = otpPriceText;
      }
      let pct = parseInt(selected.getAttribute('data-discount-pct') || '0', 10) || 0;
      if (compareCents > priceCents && compareCents > 0) {
        pct = Math.round(((compareCents - priceCents) * 100) / compareCents);
      }

      textEl.textContent = pct > 0 ? pct + '% ' + suffix : suffix;

      if (priceEl) priceEl.textContent = priceText || '';
      if (compareEl) {
        if (compareText && compareCents > priceCents) {
          compareEl.textContent = compareText;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.setAttribute('hidden', '');
        }
      }
    }

    function updatePrices() {
      const isSub = subscriptionCheckbox?.checked;

      variantItems.forEach(item => {
        const priceEl = item.querySelector('.el-price');
        const compareEl = item.querySelector('.el-compare-price');

        let price = item.dataset.price;

        if (isSub && item.dataset.subscriptionPrice) {
          price = item.dataset.subscriptionPrice;
        }

        if (priceEl) priceEl.textContent = price;
        if (compareEl) compareEl.textContent = item.dataset.comparePrice;
      });

      const selected = getSelectedVariant();
      if (!selected) return;

      let activePrice = selected.dataset.price;

      if (isSub && selected.dataset.subscriptionPrice) {
        activePrice = selected.dataset.subscriptionPrice;
      }

      btnPrice.textContent = activePrice;

      if (selected.dataset.comparePrice) {
        btnCompare.textContent = selected.dataset.comparePrice;
        btnCompare.style.display = 'inline';
      } else {
        btnCompare.style.display = 'none';
      }

      if (stickyPrice) {
        stickyPrice.textContent = activePrice;
      }
    }

    // variant select
    variantItems.forEach(item => {
      item.addEventListener('click', () => {
        variantItems.forEach(v => v.classList.remove('selected'));
        item.classList.add('selected');
        variantInput.value = item.dataset.id;
        updatePrices();
        updateDiscountBar();
      });
    });

    subscriptionCheckbox?.addEventListener('change', () => {
      updatePrices();
      updateDiscountBar();
    });

    buyNowBtn.addEventListener('click', async e => {
      e.preventDefault();

      if (buyNowBtn.classList.contains('el-loading')) return;

      const selected = getSelectedVariant();
      if (!selected) {
        isCheckingOut = false;
        return;
      }

      const variantId = selected.dataset.id;
      const isSub = subscriptionCheckbox?.checked;
      const sellingPlanId = selected.dataset.sellingPlanId;

      buyNowBtn.classList.add('el-loading');
      buyNowBtn.setAttribute('disabled', true);

      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        const items = [];

        const mainItem = {
          id: variantId,
          quantity: 1
        };

        if (isSub && sellingPlanId) {
          mainItem.selling_plan = sellingPlanId;
        }

        items.push(mainItem);

        const discountCodes = [];

        selected.querySelectorAll('.product-offer__prod-item').forEach(gift => {
          items.push({
            id: Number(gift.dataset.value),
            quantity: Number(gift.dataset.quantity || 1)
          });

          if (gift.dataset.discountCode) {
            discountCodes.push(gift.dataset.discountCode);
          }
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const code = discountCodes[0];

        if (code) {
          window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
        } else {
          window.location.href = '/checkout';
        }

      } catch (err) {
        console.error(err);

        buyNowBtn.classList.remove('el-loading');
        buyNowBtn.removeAttribute('disabled');

        isCheckingOut = false;
      }
    });

    updatePrices();
    updateDiscountBar();
  });
});

// sticky button
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.el-site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});

window.addEventListener('pageshow', () => {
  isCheckingOut = false;

  document.querySelectorAll('.product-offer').forEach(section => {
    const btn = section.querySelector('[id^="buy-now"]');
    if (!btn) return;

    btn.classList.remove('el-loading');
    btn.disabled = false;
  });
});

// faq
document.addEventListener('DOMContentLoaded', function () {
  function initAccordions() {
    const containers = document.querySelectorAll('.product-offer__accordion-container');

    containers.forEach(container => {
      const isHidden = window.getComputedStyle(container).display === 'none';
      if (isHidden) return;

      const items = container.querySelectorAll('.product-offer__acc-item');

      items.forEach(item => {
        // prevent duplicate event binding
        if (item.dataset.initialized === 'true') return;
        item.dataset.initialized = 'true';

        const trigger = item.querySelector('.product-offer__acc-item-title');
        const content = item.querySelector('.product-offer__acc-item-description');

        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.paddingBottom = '0px';

        trigger.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');

          items.forEach(otherItem => {
            const otherContent = otherItem.querySelector('.product-offer__acc-item-description');

            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
              otherContent.style.height = '0px';
              otherContent.style.paddingBottom = '0px';
            }
          });

          if (isOpen) {
            content.style.height = '0px';
            content.style.paddingBottom = '0px';
            item.classList.remove('is-open');
          } else {
            item.classList.add('is-open');

            content.style.height = 'auto';
            const fullHeight = content.scrollHeight + 'px';
            content.style.height = '0px';

            requestAnimationFrame(() => {
              content.style.height = fullHeight;
              content.style.paddingBottom = '20px';
            });
          }
        });
      });
    });
  }

  // run on load
  initAccordions();

  // re-run on resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initAccordions();
    }, 200);
  });
});
